import {DrupalSearchApiResponseMeta, DrupalVideoMedia, FacetFilters} from "types/hygiena-types";
import {DrupalJsonApiParams} from "drupal-jsonapi-params";

interface VideoData {
  videos?: DrupalVideoMedia[],
  meta?: DrupalSearchApiResponseMeta,
}

export interface Filter {
  path: string,
  value: string,
  operator: string,
}

/**
 * Searches the video library.
 *
 * @param filters
 *   Filters to apply.
 * @param pageLimit
 *   The page limit.
 * @param pageOffset
 *   The current page offset.
 * @param locale
 *   The current locale i.e. en.
 * @param defaultLocale
 *   The default locale i.e. en.
 */
export async function videoSearch(filters: FacetFilters, pageLimit: number, pageOffset: number, locale?: string, defaultLocale?: string) {
  let ok = true;
  let data = {} as VideoData;

  try {
    const params = new DrupalJsonApiParams()
      .addInclude([
        "field_video_categories",
        "field_video_thumbnail.image",
        "field_video_thumbnail.bf_image",
        "thumbnail"
      ])
      .addFilter("status", "1")
      .addFilter("mid", "0", ">")
      .addPageLimit(pageLimit)
      .addPageOffset(pageOffset)
      // .addSort("field_document_categories_weight", "ASC")
      .addSort("name", "ASC")
      .addSort("created", "DESC");
      if (locale) {
        params.addFilter("language_with_fallback", locale);
      }

      // Cache bust.
      params.addCustomParam({'timeStamp': new Date().getTime().toString()});

    for (const key of Object.keys(filters)) {
      if (key === 'video_search') {
        params.addFilter('fulltext', filters[key]);
      }
      else {
        params.addFilter(key, filters[key]);
      }
    }

    // Add the locale prefix if not en.
    const res = await fetch(`/api/search/video`, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Cache-Control": "no-cache",
        "Pragma": "no-cache",
        "Expires": "0"
      },
      body: JSON.stringify({
        locale,
        params: params.getQueryObject(),
      }),
      cache: "no-store",
    });

    const json = await res.json();
    data.videos = json?.videos ?? [];
    data.meta = json?.meta;
  }
  catch (error) {
    ok = false;
    console.log(error.message);
  }

  return {ok, data};
}
